import { GetRequestsResponse, GetRequestComments, Request } from "types/requests";
import { RequestType } from "api-client/models/RequestType";

export enum ACTIONS {
    GET_REQUESTS_REQUEST = "REQUEST/GET_REQUESTS_REQUEST",
    GET_REQUESTS_SUCCESS = "REQUEST/GET_REQUESTS_SUCCESS",
    GET_REQUESTS_FAILURE = "REQUEST/GET_REQUESTS_FAILURE",

    GET_AVAILABLE_ISSUE_TYPES_REQUEST = "REQUEST/GET_AVAILABLE_ISSUE_TYPES_REQUEST",
    GET_AVAILABLE_ISSUE_TYPES_SUCCESS = "REQUEST/GET_AVAILABLE_ISSUE_TYPES_SUCCESS",
    GET_AVAILABLE_ISSUE_TYPES_FAILURE = "REQUEST/GET_AVAILABLE_ISSUE_TYPES_FAILURE",

    CREATE_REQUEST_REQUEST = "REQUEST/CREATE_REQUEST_REQUEST",
    CREATE_REQUEST_SUCCESS = "REQUEST/CREATE_REQUEST_SUCCESS",
    CREATE_REQUEST_FAILURE = "REQUEST/CREATE_REQUEST_FAILURE",

    GET_REQUEST_COMMENTS_REQUEST= "REQUEST/GET_REQUEST_COMMENTS_REQUEST",
    GET_REQUEST_COMMENTS_SUCCESS= "REQUEST/GET_REQUEST_COMMENTS_SUCCESS",
    GET_REQUEST_COMMENTS_FAILURE= "REQUEST/GET_REQUEST_COMMENTS_FAILURE"
}


interface GetRequestCommentsRequest {
    type: ACTIONS.GET_REQUEST_COMMENTS_REQUEST
}

interface GetRequestCommentsSuccess {
    type: ACTIONS.GET_REQUEST_COMMENTS_SUCCESS
    payload: GetRequestComments;
}

interface GetRequestCommentsFailure {
    type: ACTIONS.GET_REQUEST_COMMENTS_FAILURE
}
interface GetRequestsRequest {
    type: ACTIONS.GET_REQUESTS_REQUEST;
}

interface GetRequestsSuccess {
    type: ACTIONS.GET_REQUESTS_SUCCESS;
    payload: GetRequestsResponse;
}

interface GetRequestsFailure {
    type: ACTIONS.GET_REQUESTS_FAILURE;
}

interface GetAvailableIssueTypesRequest {
    type: ACTIONS.GET_AVAILABLE_ISSUE_TYPES_REQUEST;
}

interface GetAvailableIssueTypesSuccess {
    type: ACTIONS.GET_AVAILABLE_ISSUE_TYPES_SUCCESS;
    payload: RequestType[];
}

interface GetAvailableIssueTypesFailure {
    type: ACTIONS.GET_AVAILABLE_ISSUE_TYPES_FAILURE;
}

interface CreateRequestRequest {
    type: ACTIONS.CREATE_REQUEST_REQUEST;
}

interface CreateRequestSuccess {
    type: ACTIONS.CREATE_REQUEST_SUCCESS;
    payload: Request;
}

interface CreateRequestFailure {
    type: ACTIONS.CREATE_REQUEST_FAILURE;
}

export type ActionType =
    | GetRequestsRequest
    | GetRequestsSuccess
    | GetRequestsFailure
    | CreateRequestRequest
    | CreateRequestSuccess
    | CreateRequestFailure
    | GetAvailableIssueTypesRequest
    | GetAvailableIssueTypesSuccess
    | GetAvailableIssueTypesFailure
    | GetRequestCommentsRequest
    | GetRequestCommentsSuccess
    | GetRequestCommentsFailure
